"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AutoCompleteInput = AutoCompleteInput;
var _react = _interopRequireDefault(require("react"));
var _client = require("@apollo/client");
var _reactHookForm = require("react-hook-form");
var _TextField = _interopRequireDefault(require("@mui/material/TextField"));
var _Autocomplete = _interopRequireDefault(require("@mui/material/Autocomplete"));
var _lodash = require("lodash");
var _utilities = require("@apollo/client/utilities");
var _Stack = _interopRequireDefault(require("@mui/material/Stack"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function AutoCompleteInput({
  control,
  field,
  query,
  label,
  errors,
  initialValue,
  sx = {
    width: 300
  }
}) {
  label = label || (0, _lodash.capitalize)(field);
  const [getValues, {
    data
  }] = (0, _client.useLazyQuery)(query);
  // Will not work for multiple queries
  const selection = query.definitions[0].selectionSet.selections[0].name.value;
  // const options =
  //   games?.games?.map((game) => game[label]).filter((value) => value != null) ||
  //   []
  const options = data?.[selection]?.map(x => x[field]).filter(value => value != null) || [];
  const hasError = Boolean(errors) && Boolean(errors[field]);
  const handleFocus = (e, cb) => {
    cb(); // issue query
  };
  const handleChange = (e, newValue, onChange) => {
    onChange(!!e.target.value ? e.target.value : newValue);
  };
  return /*#__PURE__*/_react.default.createElement(_reactHookForm.Controller, {
    name: field,
    control: control,
    render: ({
      field: {
        onChange,
        value,
        ...rest
      }
    }) => {
      return /*#__PURE__*/_react.default.createElement(_Stack.default, {
        direction: "column",
        spacing: 0
      }, /*#__PURE__*/_react.default.createElement(_Autocomplete.default, {
        sx: sx,
        freeSolo: true,
        size: "small",
        options: options,
        getOptionLabel: option => option.toString(),
        onFocus: e => handleFocus(e, getValues),
        onChange: (e, newValue) => handleChange(e, newValue, onChange),
        onInputChange: (e, newValue) => handleChange(e, newValue, onChange),
        renderInput: params => {
          // An initial input value can optionally be passed
          const newParams = {
            ...params,
            inputProps: {
              ...params.inputProps,
              value: value || initialValue || ''
            }
          };
          return /*#__PURE__*/_react.default.createElement(_TextField.default, _extends({}, hasError ? {
            error: true
          } : {}, {
            value: value
          }, newParams, {
            label: (0, _lodash.capitalize)(label),
            helperText: hasError ? errors[field].message : ''
          }));
        }
      }));
    }
  });
}